<div class="panel" [ngClass]="{ pin: pinned, open: isOpened }">
    <div class="data-wrapper">
        @if (!isLoading) {
            <ng-container>
                <dx-toolbar class="panel-toolbar">
                    <dxi-item location="after" [visible]="isPinEnabled">
                        <dx-button
                            stylingMode="text"
                            [icon]="pinned ? 'pin' : 'unpin'"
                            (onClick)="onPinClick()"
                        ></dx-button>
                    </dxi-item>
                    <dxi-item location="after">
                        <dx-button
                            icon="close"
                            stylingMode="text"
                            (onClick)="onClosePanel()"></dx-button>
                    </dxi-item>
                </dx-toolbar>

                <dx-scroll-view class="panel-scroll">
                    <dx-validation-group>
                        <div class="data-part border p-3">
                            <ng-content></ng-content>
                        </div>

                        @if (showToolbar && buttons.length > 0) {
                            <div class="data-part data-part-toolbar border">
                                <dx-toolbar>
                                    @for (button of buttons; track button) {
                                        <dxi-item location="after">
                                            <dx-button
                                                [text]="button.text"
                                                [icon]="button.icon"
                                                stylingMode="contained"
                                                type="default"
                                                (onClick)="button.onClick()"
                                            >
                                            </dx-button>
                                        </dxi-item>
                                    }
                                </dx-toolbar>
                            </div>
                        }
                    </dx-validation-group>
                </dx-scroll-view>
            </ng-container>
        }

        <dx-load-panel
            container=".panel"
            [width]="300"
            [visible]="isLoading"
            [showPane]="false"
            [position]="{ of: '.panel' }"
        ></dx-load-panel>
    </div>
</div>
